import {
  Box,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import { selectActiveSession } from "app/modules/schools/selectors";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setSelectedSession } from "app/modules/schools/operations";
import { Close } from "@mui/icons-material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import appRoutes from "app/config/routes";
import { getEnquiryByName } from "app/services/schoolService/admissionEnquiry.service";
import { formatGuardianString } from "app/utils/helper";
import useDebounce from "app/hooks/globallyApplicable/useDebounce";

const EnquiryStudentNameSearch = ({ onChecked = () => {} }) => {
  const [state, setState] = useState({
    name: "",
    page: 1,
    studentData: {},
    menuOpen: false,
    selectedStudent: [],
    isFocus: false,
    reRender: false,
  });
  const [searchVal, setSearchVal] = useState("");
  const debounceVal = useDebounce(searchVal, 500);
  const selectedSession = useSelector(selectActiveSession);
  const {
    isFetching: getEnquiryByNameFetching,
    isLoading: getEnquiryByNameLoading,
  } = useQuery({
    queryKey: ["getEnquiryByName", debounceVal, state.page],
    queryFn: () =>
      getEnquiryByName({
        session: selectedSession,
        studentName: debounceVal,
        page: state.page,
      }),
    onSuccess: (data) => {
      if (state.page !== 1) {
        setState((prev) => ({
          ...prev,
          studentData: { ...prev.studentData, ...data?.data },
        }));
      } else {
        setState((prev) => ({ ...prev, studentData: data?.data }));
      }
    },
    onError: ({ response: { data } }) => {
      toast.error(data?.message);
    },
    enabled: debounceVal ? true : false,
  });
  const variants = {
    open: { opacity: 1 },
    closed: { opacity: 0 },
  };
  useEffect(() => {
    const filteredDocIdList = state.studentData?.list?.filter(
      (item) => item?.checked
    );
    onChecked(filteredDocIdList);
  }, [state.reRender]);

  return (
    <ClickAwayListener
      onClickAway={() => setState((prev) => ({ ...prev, isFocus: false }))}
    >
      <Wrapper>
        <div className="input_box">
          <input
            onFocus={() => setState((prev) => ({ ...prev, isFocus: true }))}
            placeholder="Search Student"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            className="custom_input"
          />
          {debounceVal && (
            <div
              onClick={() => {
                setState((prev) => ({ ...prev, studentData: {} }));
                setSearchVal("");
              }}
            >
              <Close className="close_icon" />
            </div>
          )}
        </div>
        {/* box */}
        {searchVal && state.isFocus && (
          <div className="student_box__wrapper">
            <div className="student_box">
              {(getEnquiryByNameFetching || getEnquiryByNameLoading) && (
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  sx={{ position: "absolute", left: 0, right: 0 }}
                >
                  <CircularProgress />
                </Stack>
              )}

              {state.studentData?.list?.map((item, ind) => (
                <Box my={1} key={ind}>
                  <Stack direction={"row"} alignItems={"center"} gap={2}>
                    <Checkbox
                      color="secondary"
                      checked={item?.checked ? true : false}
                      onChange={() => {
                        item.checked = !item?.checked;
                        setState((prev) => ({
                          ...prev,
                          reRender: !prev.reRender,
                        }));
                      }}
                    />
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems={"center"}
                      px={2}
                    >
                      {/* student profile pic */}
                      <div>
                        <img
                          src={
                            item?.profilePic
                              ? item?.profilePic
                              : "/image-placeholder.jpeg"
                          }
                          alt="student"
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      {/* student details */}
                      <Stack>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "15px",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                          }}
                        >
                          {item?.name}
                        </Typography>

                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "12px",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                          }}
                        >
                          {formatGuardianString(item?.gender, item?.fatherName || item?.motherName || "")}
                        </Typography>
                        <Stack direction={"row"} gap={2} alignItems={"center"}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "12px",
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                            }}
                          >
                            Reg No:- {item?.registrationNumber}
                          </Typography>

                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "12px",
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                            }}
                          >
                            Adm No:- {item?.admissionNumber}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                  <Divider sx={{ background: "rgba(0,0,0,0.3)", mt: 1 }} />
                </Box>
              ))}
              {state.studentData?.pages !== state.studentData?.page && (
                <Stack direction={"row"} justifyContent={"center"}>
                  <Typography
                    sx={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      textAlign: "center",
                      display: "inline-block",
                      mb: 1,
                    }}
                    onClick={() =>
                      setState((prev) => ({ ...prev, page: prev.page + 1 }))
                    }
                  >
                    more
                  </Typography>
                </Stack>
              )}
            </div>
          </div>
        )}
      </Wrapper>
    </ClickAwayListener>
  );
};

export default EnquiryStudentNameSearch;
const Wrapper = styled(Box)`
  position: relative;
  transition: all 0.5s;
  .input_box {
    padding: 3px;
    border: 0.6px solid rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 300px;
    background-color: #fff;
    border-radius: 5px;
    :hover {
      border-color: var(--primary);
    }
    :focus-within {
      border: 2px solid var(--primary);
    }
  }
  .close_icon {
    font-size: 10px;
    opacity: 0.6;
    background-color: #f1f1;
    cursor: pointer;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .custom_input {
    width: 100%;
    outline: none;
    border: none;
    font-size: 14px;
    height: 30px;
  }
  .student_box__wrapper {
    position: absolute;
    width: 400px;
    height: 300px;
    padding-top: 4px;
    z-index: 300;
    .student_box {
      padding-top: 10px;
      height: 100%;
      width: 100%;
      background-color: #fff;
      border-radius: 15px;
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
      overflow-y: auto;
    }
  }
`;
